// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"147af016","247":"dc182e69","407":"2590b05e"}[chunkId] + ".chunk.js";
};